export default function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-format/src/formatNumerals.js
// module id = 485
// module chunks = 0